document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.consultant-card')

    cards?.forEach(card => {
        card.addEventListener('click', () => card.classList.toggle('closed'))
    })

});